// ets_tracing: off
import { MonocleFor } from "../../../Adt/monocle/index.mjs";
import { interpretable } from "../program-infer/index.mjs";
import { assignCallable, assignFunction, inhabitTypes, wrapFun } from "../utils/index.mjs";

const inhabitInterpreterAndAlbegra = t => t;

function interpreteWithProgram(program, programInterpreter) {
  return inhabitInterpreterAndAlbegra(inhabitTypes(assignFunction(wrapFun(program), programInterpreter(program))));
}

export function materialize(program, programInterpreter) {
  const morph = interpreteWithProgram(program, programInterpreter);
  return assignCallable(morph, { ...MonocleFor(),
    derive: interpretable(morph)
  });
}
//# sourceMappingURL=index.mjs.map